<template>
    <div id="mapPlot" style="height: 56.5vh"></div>
</template>

<script>
    import '@/assets/css/mapbox.css'
    import geojson2h3 from 'geojson2h3';
    import {h3ToGeo, geoToH3} from 'h3-js'
    import mapboxgl from 'mapbox-gl'

    export default {
        props : {
            initialExagons : {
                type : Array,
                required : false,
            }
        },

        data () {
            return {
                map : '',
                config : {
                    lng: -20.349416,
                    lat: -40.301311,
                    zoom: 11.5,
                    fillOpacity: 0.6,
                    colorScale: ['#fe6e6e', '#c67878', '#680000'],
                    resolution : 8
                },
                hexagons : []
            }
        },

        mounted () {
            this.hexagons = this.initialExagons
            this.loadMap()
        },

        methods : {
            async loadMap () {
                

                mapboxgl.accessToken = 'pk.eyJ1IjoiZ3VlZGV4IiwiYSI6ImNrZHgwZXJ1azE1dnYyeGtqcDVkbTZoNmkifQ.-MUKrlC-x-QcSNePZorASA';

                this.map = new mapboxgl.Map({
                    container : "mapPlot",
                    style : 'mapbox://styles/mapbox/light-v9',
                    center : [this.config.lat, this.config.lng],
                    zoom : 12
                })

                this.map.addControl(new mapboxgl.FullscreenControl({container: document.querySelector('deliveryDiv')}))

                this.map.on('load', () => {

                    this.map.on('click', ({ lngLat : {lng, lat} }) => {
                        const h3Index = geoToH3(lat, lng, this.config.resolution)

                        if(this.hexagons.filter(a => a == h3Index).length == 0) {
                            this.hexagons.push(h3Index)
                        } else {
                            for (let i = 0; i < this.hexagons.length; i++){
                                if(this.hexagons[i] == h3Index) {
                                    this.hexagons.splice(i, 1)
                                }
                            }
                        }

                        this.$emit('updatedHex', this.hexagons)

                        this.renderHexes(this.map, this.hexagons)
                    })
                })

                await new Promise(resolve => {
                    if (this.map.loaded()) resolve (this.map);
                    else this.map.on('load', () => resolve(this.map))
                })

                this.renderHexes(this.map, this.hexagons)
            },

            renderHexes(map, hexagons) {
                const geojson = geojson2h3.h3SetToFeatureCollection(
                    hexagons,
                    hex => ({value: hex})
                )

                const sourceId = 'h3-hexes';
                const layerId = `${sourceId}-layer`;
                let source = map.getSource(sourceId);

                if (!source) {
                    map.addSource(sourceId, {
                        type: 'geojson',
                        data: geojson
                    });
                    map.addLayer({
                        id: layerId,
                        source: sourceId,
                        type: 'fill',
                        interactive: false,
                        paint: {
                            'fill-outline-color': 'rgba(0,0,0,0)',
                        }
                    });
                    source = map.getSource(sourceId);
                }

                source.setData(geojson);

                map.setPaintProperty(layerId, 'fill-color', {
                    
                    stops: [
                        [0, this.config.colorScale[0]]
                    ]
                });

                map.setPaintProperty(layerId, 'fill-opacity', this.config.fillOpacity);
            }
        }
    }
</script>